import React from "react"
import { Link } from "gatsby"
import "./content.css"
import "./component.css"
import "./emailcontactus-content.css"
import { TiggbeePartnerContent } from "./tiggbee-partners-content"

export class BusinesspageContent extends React.Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  renderIndustryLeadersPart = () => {
    const element = (
      <>
        <div className="content-section-container">
          <div className="title">
            Industry Leaders – Inspiring the Next Generation
          </div>
          <div className="description">
            Make a powerful impact on the future workforce with minimal time commitment.
          </div>
          <br />
          <br />
          <div className="grid-layout-container" style={{ alignItems: 'flex-start' }}>
            <div className="paraph-group-container">
              <p>
                Tiggbee is an online platform that introduces your company to students through engaging, interactive video experiences. We authentically share your brand story, showcase your people, and highlight career pathways in a way that captures attention and sparks curiosity.
              </p>
              <p>
                Active in over <b>60% of U.S. states and 1,500+ schools</b>, Tiggbee helps students learn from your inspiring and diverse employees—building future customers, future talent, and future leaders.
              </p>
              <p>
                With each sponsored event, your business receives <b>five-plus minutes of focused student attention</b> delivered in an engaging video format.
              </p>
              <p>
                On average, businesses receive <b>20+ minutes of interaction</b> (per event), connecting your brand to thousands of students at scale.
              </p>
            </div>
            <div className="video-container">
              <div className="title"><div>Buzzworthy Watch</div></div>
              <video
                controls
                id='WatchTiggbeeInAction'
                preload='metadata'
                poster='https://tiggbeeweb6b99bab7c47b48e7820368aded133811-dev.s3.us-west-2.amazonaws.com/public/public-files/Tiggbee+In+Action+Thumbnail.png'
              >
                <source
                  src='https://d3luynq40dfrpk.cloudfront.net/public/public-files/Tiggbee+In+Action.mp4'
                  type="video/mp4"
                />
              </video>
              <div className="description">
                <br />
                <div className="button-group" style={{ justifyContent: "flex-start", paddingBottom: "6px" }}>
                  <Link to="/contact-us-page">
                    Contact Us
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
    return element;
  }

  renderWhyPartner = () => {
    const element = (
      <>
        <div
          className="content-section-container"
          style={{ paddingTop: "30px", paddingBottom: "30px", backgroundColor: "#F1F1F1" }}
        >
          <div className="line-title">
            <div className="text" style={{ width: "730px", backgroundColor: "#F1F1F1" }}>WHY <b>PARTNER</b> WITH TIGGBEE?</div>
            <div className="line" />
          </div>
          <div className="table-container white-table" style={{ paddingTop: "36px", paddingBottom: "36px", margin: "0px", backgroundColor: "#F1F1F1" }}>
            <div className="row">
              <div className='col-12 col-md-6 col-lg-8'>
                <ul className="icon-list" style={{ gap: "21px" }}>
                  <li>Expand marketing reach inside and beyond classrooms</li>
                  <li>Showcase career pathways and skill requirements</li>
                  <li>Shareable promo video content</li>
                  <li>Next Gen audience participation data + metrics</li>
                  <li>Empower employees to lead</li>
                  <li>Remove geographic and socioeconomic barriers</li>
                </ul>
              </div>
              <div className='col-12 col-md-6 col-lg-4'>
                <img className="mobile-image" alt="" src="/why-partner-screen.png" style={{ width: "100%" }} />
              </div>
            </div>
          </div>
        </div>
      </>
    );
    return element;
  }

  renderHowItWorksPart = () => {
    const element = (
      <>
        <div className="content-section-container" style={{ backgroundColor: "#F8C506", padding: "30px 0px", overflow: "hidden" }}>
          <div className="instruction">
            <div className="title">HOW IT WORKS</div>
            <div className="content">
              <div className="list">
                <div className="item">
                  <div className="title">Step 1. Create Your Video Event</div>
                  <ul className="description">
                    <li>We collaborate with your team to craft a compelling, authentic story featuring your people, workplace, and career pathways.</li>
                  </ul>
                </div>
                <div className="item">
                  <div className="title">Step 2. Tiggbee Delivers It Nationwide</div>
                  <ul className="description">
                    <li>Your event is assigned by educators directly inside classrooms across the U.S., ensuring maximum visibility and participation.</li>
                  </ul>
                </div>
                <div className="item">
                  <div className="title">Step 3. Students Engage — You See the Impact</div>
                  <ul className="description">
                    <li>Students watch your event, ask questions, and interact with your content for more than 20 minutes on average. You receive engagement analytics, insights, and a shareable video asset.</li>
                  </ul>
                </div>
              </div>
              <div className="background">
                <div className="image-container">
                  <img alt="" src="/how-it-works.png" />
                  <div className="frame" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
    return element;
  }

  renderCreateAccountPart = () => {
    const element = (
      <>
        <div
          className="content-section-container"
          style={{ paddingTop: "30px", paddingBottom: "30px", backgroundColor: "#F1F1F1" }}
        >
          <div className="button-group">
            <Link to="https://event.tiggbee.com/authentication/createaccount">
              Create Account
            </Link>
          </div>
        </div>
      </>
    );
    return element;
  }

  renderQuotaPart = () => {
    const element = (
      <>
        <div className="content-section-container" style={{ paddingTop: "72px", paddingBottom: "72px" }}>
          <div className="table-container white-table" style={{ padding: "0px", marginTop: "0px", marginBottom: "0px" }}>
            <div className="row">
              <div className="col-12 col-lg-2 col-xl-1">
                <div className="quota-icon">
                  <img alt="" src="/quota-icon.png" />
                </div>
              </div>
              <div className="col-12 col-lg-10 col-xl-11">
                <div className="paraph-group-container" style={{ fontStyle: "italic", textAlign: "justify" }}>
                  <p style={{ lineHeight: '36px' }}>
                    “This is a great product – definitely ticks all the boxes I was hoping it would, and more! I’m very happy with [Tiggbee’s] work.” — Colin M., Chief, Marketing Division, U.S. Coast Guardrovides excellent exposure to different careers and enhances their overall education.” — Dylan L., Vice Principal, NY
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
    return element
  }

  render() {
    const html = (
      <>
        {this.renderIndustryLeadersPart()}
        {this.renderWhyPartner()}
        {this.renderHowItWorksPart()}
        {this.renderCreateAccountPart()}
        <TiggbeePartnerContent />
        {this.renderQuotaPart()}
      </>
    )
    return html
  }
}
